import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../wayfinder'
/**
 * @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
 * @route '/pulse'
 */
export const pulse = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pulse.url(options),
    method: 'get',
})

pulse.definition = {
    methods: ["get","head"],
    url: '/pulse',
} satisfies RouteDefinition<["get","head"]>

/**
 * @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
 * @route '/pulse'
 */
pulse.url = (options?: RouteQueryOptions) => {
    return pulse.definition.url + queryParams(options)
}

/**
 * @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
 * @route '/pulse'
 */
pulse.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pulse.url(options),
    method: 'get',
})
/**
 * @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
 * @route '/pulse'
 */
pulse.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: pulse.url(options),
    method: 'head',
})

    /**
 * @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
 * @route '/pulse'
 */
    const pulseForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: pulse.url(options),
        method: 'get',
    })

            /**
 * @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
 * @route '/pulse'
 */
        pulseForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: pulse.url(options),
            method: 'get',
        })
            /**
 * @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
 * @route '/pulse'
 */
        pulseForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: pulse.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    pulse.form = pulseForm
/**
* @see \App\Http\Controllers\AuthController::login
 * @see app/Http/Controllers/AuthController.php:195
 * @route '/login'
 */
export const login = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: login.url(options),
    method: 'post',
})

login.definition = {
    methods: ["post"],
    url: '/login',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::login
 * @see app/Http/Controllers/AuthController.php:195
 * @route '/login'
 */
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::login
 * @see app/Http/Controllers/AuthController.php:195
 * @route '/login'
 */
login.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: login.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::login
 * @see app/Http/Controllers/AuthController.php:195
 * @route '/login'
 */
    const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: login.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::login
 * @see app/Http/Controllers/AuthController.php:195
 * @route '/login'
 */
        loginForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: login.url(options),
            method: 'post',
        })
    
    login.form = loginForm
/**
* @see \App\Http\Controllers\AppController::contact
 * @see app/Http/Controllers/AppController.php:210
 * @route '/contact'
 */
export const contact = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: contact.url(options),
    method: 'post',
})

contact.definition = {
    methods: ["post"],
    url: '/contact',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AppController::contact
 * @see app/Http/Controllers/AppController.php:210
 * @route '/contact'
 */
contact.url = (options?: RouteQueryOptions) => {
    return contact.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AppController::contact
 * @see app/Http/Controllers/AppController.php:210
 * @route '/contact'
 */
contact.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: contact.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AppController::contact
 * @see app/Http/Controllers/AppController.php:210
 * @route '/contact'
 */
    const contactForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: contact.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AppController::contact
 * @see app/Http/Controllers/AppController.php:210
 * @route '/contact'
 */
        contactForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: contact.url(options),
            method: 'post',
        })
    
    contact.form = contactForm
/**
* @see \App\Http\Controllers\AppController::accessibility
 * @see app/Http/Controllers/AppController.php:215
 * @route '/accessibility'
 */
export const accessibility = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: accessibility.url(options),
    method: 'post',
})

accessibility.definition = {
    methods: ["post"],
    url: '/accessibility',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AppController::accessibility
 * @see app/Http/Controllers/AppController.php:215
 * @route '/accessibility'
 */
accessibility.url = (options?: RouteQueryOptions) => {
    return accessibility.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AppController::accessibility
 * @see app/Http/Controllers/AppController.php:215
 * @route '/accessibility'
 */
accessibility.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: accessibility.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AppController::accessibility
 * @see app/Http/Controllers/AppController.php:215
 * @route '/accessibility'
 */
    const accessibilityForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: accessibility.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AppController::accessibility
 * @see app/Http/Controllers/AppController.php:215
 * @route '/accessibility'
 */
        accessibilityForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: accessibility.url(options),
            method: 'post',
        })
    
    accessibility.form = accessibilityForm
/**
* @see \App\Http\Controllers\AuthController::reauthenticate
 * @see app/Http/Controllers/AuthController.php:839
 * @route '/reauthenticate'
 */
export const reauthenticate = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reauthenticate.url(options),
    method: 'post',
})

reauthenticate.definition = {
    methods: ["post"],
    url: '/reauthenticate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::reauthenticate
 * @see app/Http/Controllers/AuthController.php:839
 * @route '/reauthenticate'
 */
reauthenticate.url = (options?: RouteQueryOptions) => {
    return reauthenticate.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::reauthenticate
 * @see app/Http/Controllers/AuthController.php:839
 * @route '/reauthenticate'
 */
reauthenticate.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reauthenticate.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::reauthenticate
 * @see app/Http/Controllers/AuthController.php:839
 * @route '/reauthenticate'
 */
    const reauthenticateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: reauthenticate.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::reauthenticate
 * @see app/Http/Controllers/AuthController.php:839
 * @route '/reauthenticate'
 */
        reauthenticateForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: reauthenticate.url(options),
            method: 'post',
        })
    
    reauthenticate.form = reauthenticateForm
/**
* @see \App\Http\Controllers\AppController::home
 * @see app/Http/Controllers/AppController.php:97
 * @route '/'
 */
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AppController::home
 * @see app/Http/Controllers/AppController.php:97
 * @route '/'
 */
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AppController::home
 * @see app/Http/Controllers/AppController.php:97
 * @route '/'
 */
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AppController::home
 * @see app/Http/Controllers/AppController.php:97
 * @route '/'
 */
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AppController::home
 * @see app/Http/Controllers/AppController.php:97
 * @route '/'
 */
    const homeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: home.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AppController::home
 * @see app/Http/Controllers/AppController.php:97
 * @route '/'
 */
        homeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: home.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AppController::home
 * @see app/Http/Controllers/AppController.php:97
 * @route '/'
 */
        homeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: home.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    home.form = homeForm
/**
* @see \App\Http\Controllers\AppController::propertyAccess
 * @see app/Http/Controllers/AppController.php:181
 * @route '/property-access/{secret}'
 */
export const propertyAccess = (args: { secret: string | number } | [secret: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: propertyAccess.url(args, options),
    method: 'get',
})

propertyAccess.definition = {
    methods: ["get","head"],
    url: '/property-access/{secret}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AppController::propertyAccess
 * @see app/Http/Controllers/AppController.php:181
 * @route '/property-access/{secret}'
 */
propertyAccess.url = (args: { secret: string | number } | [secret: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { secret: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    secret: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        secret: args.secret,
                }

    return propertyAccess.definition.url
            .replace('{secret}', parsedArgs.secret.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AppController::propertyAccess
 * @see app/Http/Controllers/AppController.php:181
 * @route '/property-access/{secret}'
 */
propertyAccess.get = (args: { secret: string | number } | [secret: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: propertyAccess.url(args, options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AppController::propertyAccess
 * @see app/Http/Controllers/AppController.php:181
 * @route '/property-access/{secret}'
 */
propertyAccess.head = (args: { secret: string | number } | [secret: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: propertyAccess.url(args, options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AppController::propertyAccess
 * @see app/Http/Controllers/AppController.php:181
 * @route '/property-access/{secret}'
 */
    const propertyAccessForm = (args: { secret: string | number } | [secret: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: propertyAccess.url(args, options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AppController::propertyAccess
 * @see app/Http/Controllers/AppController.php:181
 * @route '/property-access/{secret}'
 */
        propertyAccessForm.get = (args: { secret: string | number } | [secret: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: propertyAccess.url(args, options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AppController::propertyAccess
 * @see app/Http/Controllers/AppController.php:181
 * @route '/property-access/{secret}'
 */
        propertyAccessForm.head = (args: { secret: string | number } | [secret: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: propertyAccess.url(args, {
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    propertyAccess.form = propertyAccessForm